module.exports = __webpack_public_path__ + "static/khanh-70b7fc245ccf4e434894497d2abc785f.jpg";